import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'sazonalizacaoGd'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/contratos_gd/${id}/sazonalizacoes_gd`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/sazonalizacoes_gd/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingSazonalizacaoGdSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingSazonalizacaoGdSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_SAZONALIZACAO_GD_SUCCESS =
  'LOADING_SAZONALIZACAO_GD_SUCCESS'
export function loadingSazonalizacaoGdSuccess(sazonalizacaoGd) {
  return {
    type: LOADING_SAZONALIZACAO_GD_SUCCESS,
    sazonalizacaoGd,
  }
}

export const DESTROYING_SAZONALIZACAO_GD_SUCCESS =
  'DESTROYING_SAZONALIZACAO_GD_SUCCESS'
export function destroyingSazonalizacaoGdSuccess(sazonalizacaoGdId) {
  return {
    type: DESTROYING_SAZONALIZACAO_GD_SUCCESS,
    sazonalizacaoGdId,
  }
}

export function fetchMultipleSazonalizacaoGd(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchSazonalizacaoGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createSazonalizacaoGd(parentId, sazonalizacaoGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.CREATE, parentId),
      'POST',
      sazonalizacaoGd
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateSazonalizacaoGd(id, sazonalizacaoGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', sazonalizacaoGd).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroySazonalizacaoGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const sazonalizacaoGd = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_SAZONALIZACAO_GD_SUCCESS: {
      const { sazonalizacaoGd: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_SAZONALIZACAO_GD_SUCCESS:
      return state.delete(action.sazonalizacaoGdId.toString())

    default:
      return state
  }
}

export default sazonalizacaoGd
